var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCredential = function SvgCredential(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56.629,
    height: 78.518,
    viewBox: "0 0 56.629 78.518",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5743",
    "data-name": "Group 5743",
    transform: "translate(6 -356)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5742",
    "data-name": "Group 5742",
    transform: "translate(-6 346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5740",
    "data-name": "Group 5740",
    transform: "translate(0 11.799)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5735",
    "data-name": "Group 5735"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6593",
    "data-name": "Rectangle 6593",
    width: 51.941,
    height: 68.172,
    transform: "translate(1.196 1.267)",
    fill: "#82c3e2",
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6594",
    "data-name": "Rectangle 6594",
    width: 51.941,
    height: 68.172,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "CERTIFICATE",
    transform: "translate(36.893 10.448)",
    fill: "#4d9afd",
    fontSize: 7,
    fontFamily: "BebasNeueRegular, Bebas Neue"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -26.005,
    y: 0
  }, "CERTIFICATE")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6595",
    "data-name": "Rectangle 6595",
    width: 13.926,
    height: 0.733,
    transform: "translate(18.544 15.408)",
    fill: "#4d9afd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5736",
    "data-name": "Group 5736",
    transform: "translate(18.544 31.433)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6596",
    "data-name": "Rectangle 6596",
    width: 13.926,
    height: 0.733,
    fill: "#4d9afd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6597",
    "data-name": "Rectangle 6597",
    width: 13.926,
    height: 0.733,
    transform: "translate(0 1.74)",
    fill: "#4d9afd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6598",
    "data-name": "Rectangle 6598",
    width: 13.926,
    height: 0.733,
    transform: "translate(0 3.678)",
    fill: "#4d9afd"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6599",
    "data-name": "Rectangle 6599",
    width: 28.725,
    height: 0.733,
    transform: "translate(11.459 17.52)",
    fill: "#4d9afd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6600",
    "data-name": "Rectangle 6600",
    width: 23.953,
    height: 0.733,
    transform: "translate(13.531 23.139)",
    fill: "#4d9afd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6601",
    "data-name": "Rectangle 6601",
    width: 23.953,
    height: 0.733,
    transform: "translate(13.531 25.18)",
    fill: "#4d9afd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6602",
    "data-name": "Rectangle 6602",
    width: 23.953,
    height: 0.733,
    transform: "translate(13.531 27.379)",
    fill: "#4d9afd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6603",
    "data-name": "Rectangle 6603",
    width: 48.069,
    height: 63.726,
    transform: "translate(1.934 2.117)",
    fill: "none",
    stroke: "#add4f2",
    strokeMiterlimit: 10,
    strokeWidth: 1.017
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5739",
    "data-name": "Group 5739",
    transform: "translate(12.487 39.799)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5737",
    "data-name": "Group 5737",
    transform: "translate(8.107 18.173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77598",
    "data-name": "Path 77598",
    d: "M245.329,315.193l-5.376-2.39-5.376,2.39V297.216h10.752Z",
    transform: "translate(-234.577 -297.216)",
    fill: "#00bfa6",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_77599",
    "data-name": "Path 77599",
    d: "M237.8,300.669v14.256l3.982-1.9,4.133,1.9V300.669",
    transform: "translate(-228.364 -281.071)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.528
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5738",
    "data-name": "Group 5738"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77600",
    "data-name": "Path 77600",
    d: "M228.442,253.883l1.371-.718,1.306.979,1.567-.49.979,1.208H235.3l.849,1.5,1.371.261.392,1.436,1.567.718v1.437l1.371.849V262.7l1.045,1.241-.522,1.385.522,1.422-.588,1.436.588,1.371-1.11,1.175.065,1.632-1.306.979v1.436l-1.436.588L237.583,277h-1.436l-.979,1.567H233.73l-1.11,1.241-1.371-.522-1.371,1.045-1.436-.588-1.436.588-1.241-.914-1.5.326-1.045-1.11h-1.567l-.849-1.436-1.5-.392-.392-1.5-1.5-.522v-1.371l-1.5-1.11v-1.7l-.718-1.045.392-1.5-.653-1.306.849-1.422-.522-1.32.914-1.175-.065-1.763,1.11-.784.261-1.632,1.436-.522.457-1.632,1.436-.2.784-1.371h1.763l.718-1.11,1.7.326,1.371-.979Z",
    transform: "translate(-214.926 -253.165)",
    fill: "#fec456"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_407",
    "data-name": "Ellipse 407",
    cx: 10.159,
    cy: 10.159,
    r: 10.159,
    transform: "translate(3.324 3.422)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_408",
    "data-name": "Ellipse 408",
    cx: 9.174,
    cy: 9.174,
    r: 9.174,
    transform: "translate(2.967 21.178) rotate(-80.846)",
    fill: "#fec456"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5741",
    "data-name": "Group 5741",
    transform: "translate(40.704 10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77601",
    "data-name": "Path 77601",
    d: "M299.248,136.055a7.962,7.962,0,1,1-7.962-7.962A7.962,7.962,0,0,1,299.248,136.055Z",
    transform: "translate(-283.323 -128.093)",
    fill: "#00bfa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77602",
    "data-name": "Path 77602",
    d: "M300.421,138.553l-6.255,7-4.135-4.135,1.59-1.59,2.227,2.227,4.771-5.2Z",
    transform: "translate(-287.263 -133.241)",
    fill: "#fff"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCredential, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/credential.446e9a69.svg";
export { ForwardRef as ReactComponent };